import FilterDuck from '../redux/filters/filter.duck';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { CASH, FINANCE } from '../services/filters/filters';
import { Redux, GlobalDuck } from 'src/redux';

export const useJourneyType = () => {
    const carJourney = useSelector((state: Redux) => GlobalDuck.getOwnState(state).carJourney);
    const paymentJourneyType = useSelector(state => FilterDuck.getOwnState(state).budgetType);
    const isFinance = useMemo(() => paymentJourneyType === FINANCE, [paymentJourneyType]);
    const isCash = useMemo(() => paymentJourneyType === CASH, [paymentJourneyType]);

    return { paymentJourneyType, isFinance, isCash, carJourney };
};
